<dashboardnav>
  
    <cradua-expirationstatus
        [expirationstatuss]="expirationstatuss$ | async"
        (expirationstatus)="onSubmitExpirationStatus($event)"
        (deleteExpirationStatusEvent)="onDeleteExpirationStatus($event)"
        *ngIf="(isLoading$ | async ) === false"
        >
  </cradua-expirationstatus>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  